import React, { useState, useEffect } from 'react';
import {
  Box,
  Modal,
  ModalFooter,
  Button,
  ModalBody,
  Text,
  Input,
  Spacer,
  CardSelector,
} from '@flexisaf/flexibull2';
import PropTypes from 'prop-types';
import Theme from 'utils/theme';
import { useSelector, useDispatch } from 'react-redux';
import { selectSendingEmail } from 'redux/applicants/selector';
import { sendEmailToApplicants } from 'redux/applicants/actions';
import RichTextEditor from 'components/styles/editor.style';

export const SendMailModal = ({
  emailState,
  handleModal,
  application,
  callBack,
}) => {
  const dispatch = useDispatch();
  const { open, stage, stageName, applicants, singleApplicant } = emailState;
  const [sendTo, setSendTo] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [error, setError] = useState({
    title: '',
  });

  const sending = useSelector(selectSendingEmail);

  const closeModal = () => {
    handleModal();
    setBody('');
    setSubject('');
    setSendTo('');
    setError({
      title: '',
    });
  };

  const submit = () => {
    if (!subject) {
      setError({
        ...error,
        title: 'Kindly enter the subject of your email',
      });
      return;
    }
    const data = {
      candidateIds:
        sendTo === 'all'
          ? []
          : applicants?.map((candidate) => candidate.id) || [],
      message: body,
      subject,
      applicationId: application?.id,
      stage,
    };
    dispatch(
      sendEmailToApplicants(data, () => {
        closeModal();
        if (callBack) {
          callBack();
        }
      })
    );
  };

  useEffect(() => {
    if (open) {
      if (applicants.length > 0) {
        setSendTo('selected');
      } else {
        setSendTo('all');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <>
      <Modal open={open}>
        <ModalBody width="950px">
          <Box pad="50px">
            <Text block size="25px">
              Send Email
            </Text>
            <Spacer />
            <Text block>
              Please ensure to enter the subject and body of your email to be
              sent.
            </Text>
            <Box margin="20px 0 0">
              {!singleApplicant ? (
                <Box margin="0 -5px" pad="10px 0 15px">
                  <CardSelector
                    name="select"
                    value="1"
                    view="label"
                    label="Send Email to all Applicant(s)"
                    description={`Send email to all applicants within ${stageName} stage`}
                    type="checkbox"
                    checked={sendTo === 'all'}
                    onChange={() => setSendTo('all')}
                  />
                  {applicants.length > 0 && (
                    <CardSelector
                      name="select"
                      value="1"
                      view="label"
                      label="Send Email to selected Applicant(s)"
                      description={`Send email to selected applicant(s) within ${stageName} stage`}
                      type="checkbox"
                      checked={sendTo === 'selected'}
                      onChange={() => setSendTo('selected')}
                    />
                  )}
                </Box>
              ) : (
                <Box margin="0" pad="10px 0 15px">
                  <Text block>
                    <strong>Sending Email to:</strong>{' '}
                    {applicants[0]?.firstName} {applicants[0]?.lastName}
                  </Text>
                </Box>
              )}
              <Input
                name="Subject"
                spaceTop="30px"
                placeholder="Enter the subject of your email"
                required
                label="Subject"
                height="50px"
                width="100%"
                value={subject}
                onChange={(e) => {
                  setSubject(e.target.value);
                  setError({
                    ...error,
                    title: '',
                  });
                }}
                error={error?.title}
              />
              <Spacer space="15px" />
              <Box maxWidth="max">
                <Text uppercase style={{ fontWeight: '700' }}>
                  Body
                </Text>
                <Spacer space="10px" />
                <RichTextEditor handleChange={setBody} value={body} />
              </Box>
            </Box>
          </Box>
          <ModalFooter>
            <Box width="fit-content" margin="0 0 0 auto" pad="30px 50px">
              <Button
                height={48}
                pale
                fontColor={Theme.PrimaryRed}
                color="transparent"
                spaceRight
                spaceLeft="auto"
                onClick={() => closeModal()}
              >
                cancel
              </Button>
              <Button
                iconRight={
                  <i style={{ fontSize: '13px' }} className="saf-mail" />
                }
                height={48}
                spaceLeft
                progress={sending}
                onClick={() => submit()}
                disabled={!subject && !body}
              >
                Send Mail
              </Button>
            </Box>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </>
  );
};

SendMailModal.propTypes = {
  handleModal: PropTypes.func,
  emailState: PropTypes.object,
  application: PropTypes.object,
  callBack: PropTypes.func,
};
